/**
 * 生命周期类型
 */
export enum LifeCycleType {
    /**
     * 数据拉取成功
     */
    DATA_READY = 'data_ready',
    /**
     * 基础设施加载完成
     */
    INFRASTRUCTURE_DID_READY = 'infrastructure_did_ready',
    /**
     * 首页渲染回调
     */
    FIRST_SLIDE_RENDER = 'first_slide_render'
}

export interface LifeCycleEventsMap {
    [LifeCycleType.DATA_READY]: void,
    [LifeCycleType.INFRASTRUCTURE_DID_READY]: void,
    [LifeCycleType.FIRST_SLIDE_RENDER]: void,
}

/**
 * 对整个编辑器生命周期进行管理
 */
export interface IEditorLifeCycleService {
    /**
     * 触发某个生命周期事件
     * @param evenType
     */
    emitEvent(evenType: LifeCycleType);

    /**
     * 监听某个生命周期事件
     * @param evenType
     * @param callBack
     */
    onEvent(evenType: LifeCycleType, callBack: () => void);
}
